import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=ba7a7468&"
import script from "./statistics.ts?vue&type=script&lang=ts&"
export * from "./statistics.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports